import React, { useEffect, useCallback, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import HelpIcon from '@material-ui/icons/Help';
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import AddBoxIcon from '@material-ui/icons/AddBox';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import InfiniteScroll from 'react-infinite-scroll-component';
import Grid from '@material-ui/core/Grid';
import { CircularProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { isUndefined, isEmpty, isNull } from 'lodash';

import GroupProperties from '../FileUpload/Modals/GroupProperties';
import UnitProperties from '../FileUpload/Modals/UnitProperties';

import UnitsImage from '../../assets/images/units_image.png';
import { uploadContentService } from '../../services';

import { useHistory } from 'react-router-dom';


const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#252525",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 12,
    color: theme.palette.common.white,
    width: "50%"
  },
  button: {
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: "#424242",
      height: "140px"
    },
    '&:nth-of-type(even)': {
      backgroundColor: "#252525",
      height: "140px"
    },
  },
}))(TableRow);

function createData(SPILLELISTER, BUTTON) {
  return { SPILLELISTER, BUTTON };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  button: {
    marginTop: 10,
    height: 40,
    width: 80,
    float: 'right',
    fontSize: 15,
    fontWeight: 'bold',
    color: '#ffffff',
    backgroundColor: 'transparent'
  },
  cellGreen: {
    backgroundColor: 'green',
    width: "100%"
  },
  tableHeaderCell: {
    textAlign: 'center',
    textTransform: 'uppercase',
    width: '1290px',
  },
  headerCellItems: {
    width: '100%',
    display: 'flex'
  },
  nested: {
    paddingLeft: "32px",
    minHeight: 40,
    minWidth: 10,
    marginBottom: "10px"
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2rem 0',
    width: '100%',
    fontSize: '14px'
  },
  listItemIcon: {
    color: 'darkorange',
  },
  unitNameText: {
    width: '505px'
  },
  firstItemList: {
    marginBottom: '10px',
    paddingLeft: '0px',
    paddingRight: '0px'
  },
  dynamicRowCell: {
    // paddingLeft: '0px',
    // paddingRight: '0px'
  },
  paperElement: {
    marginTop: '20px',
    backgroundColor: 'transparent'
  },
  expandIcons: {
    marginRight: '15px'
  },
  listItemRowTitle: {
    textAlign: 'left',
    width: '50%'
  },
  listItemElement: {
    textAlign: 'center',
    width: '50%'
  },
  spanElementHeaders: {
    width: '100%'
  },
  checkCircleIcon: {
    color: '#00FF00'
  },
  cancelCircleIcon: {
    color: '#FF4500'
  },
  helpCircleIcon: {
    color: 'white'
  },
  gridDetails: {
    display: 'grid'
  },
  gridItem: {
    display: 'flex'
  },
  gridContinerEement: {
    padding: '0px 40px',
    maxHeight: '200px',
    overflow: 'auto'
  },
  addGroupButton: {
    marginLeft: '20px',
    backgroundColor: '#ff5722',
    color: 'white'
  },
  materialIcon: {
    marginRight: '5px'
  },
  anchorTag: {
    color: '#0099CC',
    cursor: 'pointer'
  },
  propertiesBtn: {
    color: '#0099CC',
    cursor: 'pointer'
  }
}));

export default function CustomizedTables() {
  const classes = useStyles();
  const history = useHistory();

  const [openGroup, setOpenGroup] = useState(false);
  const [isGroupPropertiesModalShow, setIsGroupPropertiesModalShow] = useState(false);
  const [isUnitPropertiesModalShow, setIsUnitPropertiesModalShow] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [expandItemNumber, setExpandItemNumber] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [devicesList, setDevicesList] = useState([]);
  const [detailedDevicesList, setDetailedDevicesList] = useState([]);
  const [totalGroups, setTotalGroups] = useState(null);

  const { user } = useSelector(state => state.userAuthentication);

  const handleCollapseClick = (event) => {
    setDevicesList([]);
    const groupId = parseInt(event.currentTarget.dataset.value);
    const index = event.currentTarget.dataset.index;

    if (index) {
      setExpandItemNumber(parseInt(index));
      setOpenGroup(!openGroup);

      if (groupId) {
        groupDetail(groupId);
      }
    }
  };

  const handleClick = (event) => {
    const currentTarget = event.currentTarget.dataset.value;
    const unitId = event.currentTarget.dataset.id;

    if (currentTarget === "group-properties") {
      setIsGroupPropertiesModalShow(true);
    } else if (currentTarget === "unit-properties") {
      setSelectedUnit(unitId);
      setIsUnitPropertiesModalShow(true);
    }
  }

  const groupDetail = useCallback(async (id) => {
    if (!isUndefined(user)) {
      const res = await uploadContentService.groupDetailFetch(user, id);
      const rawDevices = res?.devices;
      const idsArr = [];

      [...rawDevices].map(item => {
        return idsArr.push(item.id);
      });

      const devicesData = JSON.parse(localStorage.getItem("devices"))["devices"];

      const finalDevicesArr = devicesData.filter(item => {
        return idsArr.includes(item.id);
      })
  
      if (!isUndefined(finalDevicesArr)) {
        const perChunk = 6;
        const baseArr = finalDevicesArr;

        const reducedArr = baseArr.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index/perChunk);

          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
          }

          resultArray[chunkIndex].push(item);
          
          return resultArray;
        }, [])

        setDevicesList(reducedArr);
      }
    }
  }, [user]);

  const getGroupsList = useCallback(async () => {
    if (!isUndefined(user)) {
      const res = await uploadContentService.groupListFetch(user);
  
      if (!isUndefined(res?.items)) {
        setGroupList(res?.items);
        setTotalGroups(res?.items.length);
      }
    }
  }, [user]);
  
  useEffect(() => {
    getGroupsList();
  }, [getGroupsList]);

  const GridRow = (devices) => {
    return (
      [...devices['devices']].map(item => (
        <>
          <Grid className={classes.gridItem} item xs={2}>
            <div style={{ position: 'relative', padding: '10px 0px', marginRight: '5px' }}>
              {item.healthStatus === 'Normal' ? (
                <CheckCircleIcon style={{ position: 'absolute', marginTop: '12px', marginLeft: '20px' }} className={classes.checkCircleIcon} />
              ) : (
                item.healthStatus === 'Error' ? (
                  <CancelIcon style={{ position: 'absolute', marginTop: '12px', marginLeft: '20px' }} className={classes.cancelCircleIcon} />
                ) : (
                  item.healthStatus === 'NoSubscriptions' ? (
                    <HelpIcon style={{ position: 'absolute', marginTop: '12px', marginLeft: '20px' }} className={classes.helpCircleIcon} />
                  ) : ''
                )
              )}
              {/* <RadioIcon className={classes.radioIcon} /> */}
              <img src={UnitsImage} alt="unit" />
            </div>
            <div className={classes.gridDetails}>
              <span style={{ textOverflow: 'ellipsis', overflow: 'hidden', height: '17px' }}>{item.name}</span>
              <span style={{ textOverflow: 'ellipsis', overflow: 'hidden', height: '17px' }}>{item.presentation?.name}</span>
              <span className={classes.anchorTag} data-value="unit-properties" data-id={item.id} onClick={handleClick}>properties</span>
            </div>
          </Grid>
        </>
      ))
    )
  }

  const fetchMoreData = () => {
    if (!isUndefined(groupList) && !isNull(groupList) && !isUndefined(totalGroups) & !isNull(totalGroups)) {
      if (groupList.length >= totalGroups) {
        setHasMore(false);
        return;
      }

      // a fake async api call like which sends
      // more records in .5 secs
      setTimeout(() => {
        setGroupList([...groupList].concat(groupList));
      }, 500);
    }
  }

  return (
    <div>
      <span className="span-design">
        <div className="icon-design"><VideoLabelIcon /> Units </div>
        <h3 className="text-design">  Content</h3>
        <Button className={classes.addGroupButton} variant="contained">
          <AddBoxIcon className={classes.materialIcon} />
          Add Group
        </Button>
      </span>
      <TableContainer className={classes.paperElement} component={Paper}>
        <Table stickyHeader aria-label="customized table">
          <InfiniteScroll
            dataLength={groupList.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={<h4>Loading data...</h4>}
            height={850}
          >
            <TableHead>
              <TableRow>
                <StyledTableCell className={classes.tableHeaderCell}>
                  <div className={classes.headerCellItems}>
                    <span className={classes.spanElementHeaders} style={{ textAlign: 'left', marginLeft: '31px' }}>NAME</span>
                    <span className={classes.spanElementHeaders}>STATUS</span>
                    <span className={classes.spanElementHeaders}>PROPERTIES</span>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!isUndefined(groupList) && !isNull(groupList) ? (
                [...groupList].map((item, index) => (
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      <List className={classes.dynamicRowCell} component="nav" aria-labelledby="nested-list-subheader">
                        <ListItem className={classes.firstItemList}>
                          {/* <ExpandLess data-index={index} onClick={handleCollapseClick} className={classes.expandIcons} style={{ cursor: 'pointer' }} /> */}
                          {openGroup && expandItemNumber === index ? <ExpandLess data-value={item.id ? item.id : null} data-index={index} onClick={handleCollapseClick} className={classes.expandIcons} style={{ cursor: "pointer" }} /> : <ExpandMore data-value={item.id ? item.id : null} data-index={index} onClick={handleCollapseClick} className={classes.expandIcons} style={{ cursor: "pointer" }} />}
                          <ListItemText className={classes.listItemRowTitle} primary={item.name} />
                          <ListItemText className={classes.listItemElement}>
                            <div>
                              {item?.devicesHealthStatus?.includes('Normal') ? (
                                <CheckCircleIcon className={classes.checkCircleIcon} />
                              ) : ''}
                              {item?.devicesHealthStatus?.includes('Error') ? (
                                <CancelIcon className={classes.cancelCircleIcon} />
                              ) : ''}
                              {item?.devicesHealthStatus?.includes('NoSubscriptions') ? (
                                <HelpIcon className={classes.helpCircleIcon} />
                              ) : ''}
                            </div>
                          </ListItemText>
                          <ListItemText className={classes.listItemElement} data-value="group-properties" data-index="1" onClick={handleClick}>
                            <span className={classes.propertiesBtn}>properties</span>
                          </ListItemText>
                        </ListItem>
                        <Collapse in={expandItemNumber === index ? openGroup : false} timeout="auto" unmountOnExit>
                          <Grid className={classes.gridContinerEement} container spacing={1}>
                            {!isUndefined(devicesList) && !isNull(devicesList) && !isEmpty(devicesList) ? (
                              [...devicesList].map((item, index) => (
                                <Grid container item xs={12} spacing={3}>
                                  <GridRow devices={item} />
                                </Grid>
                              ))
                            ) : (
                              (
                                <div className={classes.loader}>
                                  <span>No Units...</span>
                                </div>
                              )
                            )}
                          </Grid>
                        </Collapse>
                      </List>
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              ) : (
                <div className={classes.loader}>
                  <CircularProgress />
                </div>
              )}
              {isGroupPropertiesModalShow ? (<GroupProperties modalShow={isGroupPropertiesModalShow} modalState={setIsGroupPropertiesModalShow} />) : ''}
              {isUnitPropertiesModalShow && !isUndefined(selectedUnit) ? (<UnitProperties unitId={selectedUnit} modalShow={isUnitPropertiesModalShow} modalState={setIsUnitPropertiesModalShow} />) : ''}
            </TableBody>
          </InfiniteScroll>
        </Table>
      </TableContainer>
    </div>
  );
}